import { ContentLayout, LoadingScreen } from '@nohara-dxdev/react-core';
import { OidcProtectedComponent, TermsAcceptanceCheck } from '@nohara-dxdev/react-oidc';
import { useTranslation } from 'react-i18next';
import { Outlet, useRouteError } from 'react-router';

import { env } from '@/config/env';
import { paths } from '@/config/paths';
import { useSyncZodWithI18n } from '@/lib/zod';

export const ErrorBoundary = () => {
  const { t } = useTranslation();
  const error = useRouteError();

  console.error(error);

  return <ContentLayout title={t('common.errors.somethingWentWrong')}>Error</ContentLayout>;
};

const AppRoot = () => {
  useSyncZodWithI18n();
  return (
    <OidcProtectedComponent redirectTo={paths.auth.login.path} fallbackElement={<LoadingScreen />}>
      <TermsAcceptanceCheck appId={env.APP_ID}>
        <Outlet />
      </TermsAcceptanceCheck>
    </OidcProtectedComponent>
  );
};

export default AppRoot;
